import React, { useCallback, useState, useEffect } from 'react';

import { FormPropriedade } from '../../components/FormPropriedade';
import { ErrorRetrievingData } from '../../components/ErrorRetrievingData';
import api from '../../api/api';
import MenuMain from '../../MenuMain';
import { AppFooter } from '../../AppFooter';

export default function EditarPropriedadePage(props) {

    const [propriedade, setPropriedade] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [errorGettingPropriedade, setErrorGettingPropriedade] = useState(false)
    const [errorMessage, setErrorMessage] = useState('');
    const [id] = useState(props.match.params.id);

    const getPropriedade = useCallback(async (id) => {
        
        try {
            setIsLoading(true);
            const response = await api.get(`propriedade/${id}`);

            setPropriedade({
                "id": response.data.id,
                "proprietarioId": response.data.proprietarioId,
                "nome": response.data.nome,
                "endereco": response.data.endereco,
                "numero": response.data.numero,
                "complemento": response.data.complemento,
                "cep": response.data.cep,
                "municipioId": response.data.municipioId,
                "areaTotal": response.data.areaTotal,
                "areaExplorada": response.data.areaExplorada,
                "areaCultivada": response.data.areaCultivada,
                "geoLocalizacao": response.data.geoLocalizacao,
                "pronaf": response.data.pronaf,
                "tipoPosse": response.data.tipoPosse
            })

           setErrorGettingPropriedade(false)
            setIsLoading(false);
        }
        catch (error) {
            setErrorMessage(error.toString())
            setErrorGettingPropriedade(true)
            setIsLoading(false);
        }
    }, []);
    
    useEffect(() => {
        const propriedade = async () => {
            await getPropriedade(id);         
        }
        propriedade();

    }, [getPropriedade,id])

    return (
        <>
            <MenuMain >

                {
                    errorGettingPropriedade ?
                        <ErrorRetrievingData
                            errorMessage={errorMessage}
                            isLoading={isLoading}
                        />
                        :
                        <FormPropriedade
                            defaultValues={propriedade}
                            isLoading={isLoading}
                            isEditing={true}
                        />
                }
            </MenuMain>
            <AppFooter />
        </>
    );
}
